import React from "react";
import Tippy from "@tippyjs/react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { InvoiceIcon } from "fe-shared/src/components/Icons";

import styles from "./InvoiceableIndicator.module.scss";

interface Props {
  isInvoiceable?: boolean;
  className?: string;
}

export const InvoiceableIndicator = ({ isInvoiceable, className }: Props) => {
  const { t } = useTranslation();

  return isInvoiceable ? (
    <Tippy content={t("transactions.invoiceable")}>
      <div className={classnames(styles.icon, className)}>
        <InvoiceIcon width={16} height={16} fillColor="#63696F" />
      </div>
    </Tippy>
  ) : null;
};

export default InvoiceableIndicator;
